import CertData from './Data.vue';

export default CertData;



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/components/data/index.ts